var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenLock = function SvgGreenLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FBC44",
    d: "M11 5h-.375a.125.125 0 0 1-.125-.125v-.844C10.5 1.823 8.694-.008 6.484 0A4 4 0 0 0 2.5 4v.875A.125.125 0 0 1 2.375 5H2A1.5 1.5 0 0 0 .5 6.5v5A1.5 1.5 0 0 0 2 13h9a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11 5M7.402 9.698a1 1 0 0 0-.402.794V11a.5.5 0 0 1-.494.5.51.51 0 0 1-.506-.51v-.49c0-.316-.15-.61-.403-.802A1.499 1.499 0 0 1 6.478 7a1.5 1.5 0 0 1 .924 2.698M9.5 4.875A.125.125 0 0 1 9.375 5h-5.75a.125.125 0 0 1-.125-.125V4c0-.802.312-1.555.878-2.122A2.99 2.99 0 0 1 6.5 1c.802 0 1.555.313 2.122.878.565.567.878 1.32.878 2.122z"
  })));
};
export default SvgGreenLock;